import { h } from 'preact';
import PropTypes from 'prop-types';

import Forms from '../forms/forms';

const Switch = ({ checked = false, label, onClick }) => {
  return (
    <Forms>
      <div className="c-forms__switch">
        <input type="checkbox" checked={checked} />
        <label className="c-forms__label c-forms__label--clickable" onClick={() => onClick?.(checked)}>
          <span />
        </label>
        {label && <label className="c-forms__label c-forms__label--not-clickable">{label}</label>}
      </div>
    </Forms>
  );
};

Switch.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default Switch;
